export default "__VITE_ASSET__53a6a443__"